<template>
  <div>
    <v-row dense>
      <v-col cols="12">
        <div class="ma-1 my-4">
          <v-sheet class="mx-auto" elevation="8">
            <v-slide-group v-model="model" class="pa-4 px-6" show-arrows>
              <v-slide-item v-slot="{ active, toggle }">
                <v-card :color="active ? 'primary' : $vuetify.theme.dark ? 'grey darken-4' : 'grey lighten-1'" class="ma-2" height="64" width="64" @click="toggle" elevation="6">
                  <v-row class="fill-height mt-1" align="center" justify="center">
                    <v-scale-transition>
                      <v-icon color="white" size="32">mdi-cellphone</v-icon>
                    </v-scale-transition>
                  </v-row>
                </v-card>
              </v-slide-item>

              <v-slide-item v-slot="{ active, toggle }">
                <v-card :color="active ? 'primary' : $vuetify.theme.dark ? 'grey darken-4' : 'grey lighten-1'" class="ma-2" height="64" width="64" @click="toggle" elevation="6">
                  <v-row class="fill-height mt-1" align="center" justify="center">
                    <v-scale-transition>
                      <v-icon color="white" size="32">mdi-book-open-page-variant-outline</v-icon>
                    </v-scale-transition>
                  </v-row>
                </v-card>
              </v-slide-item>
            </v-slide-group>

            <v-expand-transition>
              <v-sheet v-if="model != null" height="auto" tile>
                <v-row class="fill-height" align="center" justify="center">
                  <template v-if="model == 0">
                    <v-row dense class="ma-2">
                      <v-col cols="12">
                        <v-card-title>
                          <h3 style="color: yellowgreen">{{ $t("support.address") }}</h3>
                        </v-card-title>

                        <v-card-text>
                          <v-row>
                            <v-col cols="12" md="3" align="center">
                              <v-img height="auto" width="auto" max-height="160" max-width="160" src="/logo.svg">
                                <a href="https://static.energycloud.cz/ECApp-UzivatelskyManual.pdf" target="_blank"></a>
                              </v-img>
                            </v-col>

                            <v-col cols="12" md="3" align="start">
                              <div style="color: yellowgreen"><h3>EnergyCloud a.s.</h3></div>

                              <v-card-subtitle>
                                <v-icon class="ma-1" color="light-green"> mdi-home-city-outline</v-icon> <b style="color: yellowgreen">{{ $t("support.addr") }}:</b> <br />
                                <i class="text-caption" :style="getStyle">
                                  Studentská 1837/50 <br />
                                  323 00 Plzeň <br />
                                  Česká republika
                                </i>
                              </v-card-subtitle>
                            </v-col>
                          </v-row>

                          <v-row class="ma-2">
                            <v-col cols="12" md="3" sm="6" align="start">
                              <b style="color: yellowgreen">{{ $t("support.servis") }}:</b> <br />
                              <v-icon small class="ma-1" color="light-green">mdi-cellphone</v-icon> <i class="text-caption" :style="getStyle">+420 773 716 046</i> <br />
                              <v-icon small class="ma-1" color="light-green">mdi-email-outline</v-icon> <i class="text-caption" :style="getStyle">servis@energycloud.cz</i> <br />
                            </v-col>

                            <v-col cols="12" md="3" sm="6" align="start">
                              <b style="color: yellowgreen">{{ $t("support.sale") }}:</b> <br />
                              <v-icon small class="ma-1" color="light-green">mdi-cellphone</v-icon> <i class="text-caption" :style="getStyle"> +420 608 712 442</i> <br />
                              <v-icon small class="ma-1" color="light-green">mdi-email-outline</v-icon><i class="text-caption" :style="getStyle">obchod@energycloud.cz</i> <br />
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </template>

                  <template v-if="model == 1">
                    <v-row dense class="ma-2">
                      <v-col cols="12">
                        <v-card-title>
                          <h3 style="color: yellowgreen">{{ $t("support.manuals") }}</h3>
                        </v-card-title>

                        <v-card-text>
                          <v-row>
                            <v-col cols="12" md="4">
                              <b class="text-" :style="getStyle">{{ $t("support.ecapp") }}:</b> <br />
                              <v-icon class="ma-1" color="light-green">mdi-book-open-page-variant-outline</v-icon>
                              <i>
                                <a href="https://static.energycloud.cz/ECApp-UzivatelskyManual.pdf" target="_blank">{{ $t("support.userGuide") }} </a>
                              </i>
                              <br />
                            </v-col>

                            <v-col cols="12" md="12">
                              <b :style="getStyle">{{ $t("support.eess") }}:</b> <br />
                              <v-icon class="ma-1" color="light-green">mdi-book-open-page-variant-outline</v-icon>
                              <i>
                                <a href="https://static.energycloud.cz/EESS-UzivatelskyManual.pdf" target="_blank">{{ $t("support.userGuide") }} </a>
                              </i>
                              <br />
                            </v-col>

                            <template v-if="this.user.roles.includes('EC_ADMIN') || this.user.roles.includes('EC_SERVICE')">
                              <v-col cols="12" md="12">
                                <b :style="getStyle">{{ $t("support.internalGuide") }}:</b> <br />
                                <v-icon class="ma-1" color="light-green">mdi-book-open-page-variant-outline</v-icon>
                                <i>
                                  <a href="https://static.energycloud.cz/EC_InternalGuide.pdf" target="_blank">
                                    {{ $t("support.instalationGuide") }}
                                  </a>
                                </i>
                                <br />
                              </v-col>
                            </template>

                            <v-col cols="12" md="6">
                              <b :style="getStyle">{{ $t("support.singlePhase") }} - ECHH4001Pxx </b> <br />
                              <v-icon class="ma-1" color="light-green">mdi-book-open-variant</v-icon>
                              <i>
                                <a href="https://static.energycloud.cz/ECHH4001Pxx-Navod_k_instalaci_a_Prirucka_pro_udrzbu.pdf" target="_blank">{{ $t("support.installationManual") }} </a>
                              </i>
                              <br />
                              <v-icon class="ma-1" color="light-green">mdi-certificate-outline</v-icon>
                              <i>
                                <a href="https://static.energycloud.cz/ECHH4001Pxx-Prohlaseni_o_shode.pdf" target="_blank">{{ $t("support.declaration") }}</a>
                              </i>
                              <br />
                              <v-icon class="ma-1" color="light-green">mdi-bookmark-box-multiple-outline</v-icon>
                              <i>
                                <a href="https://static.energycloud.cz/ECHH4001Pxx-Technicky_list.pdf" target="_blank">{{ $t("support.datasheet") }} </a>
                              </i>
                              <br />
                              <v-icon class="ma-1" color="light-green">mdi-book-open-page-variant-outline</v-icon>
                              <i>
                                <a href="https://static.energycloud.cz/ECHH4001Pxx-Uzivatelska_prirucka.pdf" target="_blank">{{ $t("support.userGuide") }} </a>
                              </i>
                              <br />
                            </v-col>

                            <v-col cols="12" md="6">
                              <b :style="getStyle">{{ $t("support.threePhase") }} - ECHH8003P11 </b> <br />
                              <v-icon class="ma-1" color="light-green">mdi-book-open-variant</v-icon>
                              <i>
                                <a href="https://static.energycloud.cz/ECHH8003P11-Navod_k_instalaci_a_Prirucka_pro_udrzbu.pdf" target="_blank">{{ $t("support.installationManual") }} </a>
                              </i>
                              <br />
                              <v-icon class="ma-1" color="light-green">mdi-certificate-outline</v-icon
                              ><i>
                                <a href="https://static.energycloud.cz/ECHH8003P11-Prohlaseni_o_shode.pdf" target="_blank">{{ $t("support.declaration") }}</a>
                              </i>
                              <br />
                              <v-icon class="ma-1" color="light-green">mdi-bookmark-box-multiple-outline</v-icon>
                              <i>
                                <a href="https://static.energycloud.cz/ECHH8003P11-Technicky_list.pdf" target="_blank">{{ $t("support.datasheet") }}</a>
                              </i>
                              <br />
                              <v-icon class="ma-1" color="light-green">mdi-book-open-page-variant-outline</v-icon>
                              <i>
                                <a href="https://static.energycloud.cz/ECHH8003P11-Uzivatelska_prirucka.pdf" target="_blank">{{ $t("support.userGuide") }} </a>
                              </i>
                              <br />
                            </v-col>

                            <v-col cols="12" md="6">
                              <b :style="getStyle">{{ $t("support.battery") }} - ECHB800xx10 </b> <br />

                              <v-icon class="ma-1" color="light-green">mdi-book-open-variant</v-icon>
                              <i>
                                <a href="https://static.energycloud.cz/ECHB800xx10-Navod_k_instalaci_a_Prirucka_pro_udrzbu.pdf" target="_blank">{{ $t("support.installationManual") }} </a>
                              </i>
                              <br />
                              <v-icon class="ma-1" color="light-green">mdi-certificate-outline</v-icon
                              ><i>
                                <a href="https://static.energycloud.cz/ECHB800xx10-Prohlaseni_o_shode.pdf" target="_blank">{{ $t("support.declaration") }}</a>
                              </i>
                              <br />
                              <v-icon class="ma-1" color="light-green">mdi-bookmark-box-multiple-outline</v-icon>
                              <i>
                                <a href="https://static.energycloud.cz/ECHB800xx10-Technicky_list.pdf" target="_blank">{{ $t("support.datasheet") }} </a>
                              </i>
                              <br />
                              <v-icon class="ma-1" color="light-green">mdi-book-open-page-variant-outline</v-icon>
                              <i :style="getStyle">
                                <a href="https://static.energycloud.cz/ECHB800xx10-Uzivatelska_prirucka.pdf" target="_blank">{{ $t("support.userGuide") }} </a></i
                              >
                              <br />
                            </v-col>

                            <v-col cols="12" md="6">
                              <b :style="getStyle">{{ $t("support.acwb") }} - ECWBACXX022 </b> <br />
                              <v-icon class="ma-1" color="light-green">mdi-book-open-variant</v-icon>
                              <i>
                                <a href="https://static.energycloud.cz/ACWB22-Navod_k_instalaci_a_Prirucka_pro_udrzbu.pdf" target="_blank">{{ $t("support.installationManual") }} </a>
                              </i>
                              <br />
                              <v-icon class="ma-1" color="light-green">mdi-certificate-outline</v-icon
                              ><i>
                                <a href="https://static.energycloud.cz/ACWB22-Prohlaseni_o_shode.pdf" target="_blank">{{ $t("support.declaration") }}</a>
                              </i>
                              <br />
                              <v-icon class="ma-1" color="light-green">mdi-bookmark-box-multiple-outline</v-icon>
                              <i>
                                <a href="https://static.energycloud.cz/ACWB22-Technicky_list.pdf" target="_blank">{{ $t("support.datasheet") }}</a>
                              </i>
                              <br />
                              <v-icon class="ma-1" color="light-green">mdi-book-open-page-variant-outline</v-icon>
                              <i :style="getStyle">
                                <s style="color: yellowgreen">{{ $t("support.userGuide") }}</s>
                              </i>
                              <br />
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </template>
                </v-row>
              </v-sheet>
            </v-expand-transition>
          </v-sheet>
        </div>
      </v-col>
    </v-row>
    <UpgradeCore />
  </div>
</template>

<script>
import UpgradeCore from "../../components/upgrade/UpgradeCore.vue";

export default {
  components: {
    UpgradeCore,
  },
  data() {
    return {
      user: JSON.parse(sessionStorage.getItem("user")),

      model: 0,

      active: true,
    };
  },
  computed: {
    getStyle() {
      return this.$vuetify.theme.dark ? "color: #FFFFFF" : "color: #444444";
    },
  },
  mounted() {},
};
</script>

<style></style>
